module.exports = __webpack_public_path__ + "img/themeloop-dbz-mobile.bb4f8c11.png";